import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotAvailableComponent } from './components/not-available/not-available.component';
import { AuthGuardService } from './core/services/authguard.service';
import {LoginComponent} from "./components/login/login.component";

const appRoutes: Routes = [
    { path: 'login', component: LoginComponent},
    {
        path: '',
        loadChildren: () => import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule),
        canActivate: [AuthGuardService],
        data: {breadcrumb: 'Test'}
    },
    {
        path: '**',
        component: NotAvailableComponent,
        data: { breadcrumb: 'Nie dostępna strona' },
    },
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes)],
    exports: [RouterModule],
})
export class AppRoutingModule { }
